import { render } from "./UnreadOrderMessage.vue?vue&type=template&id=3b74b1aa&scoped=true"
import script from "./UnreadOrderMessage.vue?vue&type=script&lang=js"
export * from "./UnreadOrderMessage.vue?vue&type=script&lang=js"

import "./UnreadOrderMessage.vue?vue&type=style&index=0&id=3b74b1aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b74b1aa"]])

export default __exports__